import * as React from "react";

import { cn } from "~/utils/fontsConfig";

const TextArea = React.forwardRef<
    HTMLTextAreaElement,
    React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
    return (
        <textarea
            className={cn(
                "flex min-h-[60px] w-full rounded-[0.625rem] bg-v3-N-500 px-3 py-1 text-base tracking-wide shadow-none transition-colors",
                "placeholder:text-v3-N-400",
                "border-1 border-transparent hover:border-v3-clover focus:border-v3-clover focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
                "disabled:cursor-not-allowed disabled:opacity-50",
                "text-sm",
                className,
            )}
            ref={ref}
            {...props}
        />
    );
});
TextArea.displayName = "TextArea";

export { TextArea };
